<div class="questions">
  <div class="typography typography-huge questions-title">
    Часто задаваемые вопросы
  </div>
  <div class="questions-container">
    <nz-collapse>
      <nz-collapse-panel
        nzHeader="Что такое Helix Express?"
        nzShowArrow="false"
      >
        <div class="typography typography-headline">
          Это современный медицинский сервис для сдачи анализов без очередей,
          лишних бумаг и с минимумом контактов.
        </div>
      </nz-collapse-panel>
      <nz-collapse-panel
        nzHeader="Как сдать анализы через Лабомат?"
        nzShowArrow="false"
      >
        <div class="typography typography-headline">
          Скачайте мобильное приложение Helix Express и зарегистрируйтесь,
          указав личные данные. Выберите нужные анализы, оформите и оплатите
          заказ в приложении.
        </div>
        <p class="typography typography-headline">
          Приходите в пункт, где установлен Лабомат, отсканируете QR-код из
          приложения и получите набор для взятия биоматериала.
        </p>
        <p class="typography typography-headline">
          Соберите биоматериал в комфортной обстановке дома, поместите образец в
          пакет из набора.
        </p>
        <p class="typography typography-headline">
          Доставьте пакет с образцом биоматериала в пункт, где установлен
          Лабомат, и, отсканировав штрихкод на пакете, поместите его в
          специальный отсек.
        </p>
        <div class="typography typography-headline">
          Результаты анализов поступят на электронную почту и появятся в
          мобильном приложении.
        </div>
      </nz-collapse-panel>
      <nz-collapse-panel
        nzHeader="Могу ли я сдать анализ крови через Лабомат?"
        nzShowArrow="false"
      >
        <div class="typography typography-headline">
          Для сдачи анализов по крови оформите и оплатите заказ в мобильном
          приложении Helix Express.
        </div>
        <p class="typography typography-headline">
          Приходите в пункт, где установлен Лабомат, отсканируйте QR-код из
          приложения и получите талон. Пройдите с талоном в процедурный кабинет
          Медицинского центра в порядке очереди.
        </p>
        <p class="typography typography-headline">
          Медсестра не знает, какие именно анализы вы сдаете. Она отсканирует
          талон на Лейблере и получит автоматически маркированные пробирки, а
          также распечатает образец договора, который нужно подписать. Медсестра
          возьмет кровь в пробирки и отдаст их вам.
        </p>
        <div class="typography typography-headline">
          Упакуйте пробирки в пакет и доставьте в ближайший пункт, где находится
          Лабомат. Отсканировав штрихкод, положите пакет в специальный отсек.
        </div>
      </nz-collapse-panel>
      <nz-collapse-panel
        nzHeader="Какие анализы я могу сдать?"
        nzShowArrow="false"
      >
        <div class="typography typography-headline">
          В Helix Express доступны 1900 анализов. Ознакомьтесь с полым списком
          исследований в мобильном приложении.
        </div>
      </nz-collapse-panel>
    </nz-collapse>
  </div>
</div>
